import { render } from "./VendorBill.vue?vue&type=template&id=01f68b00"
import script from "./VendorBill.vue?vue&type=script&lang=js"
export * from "./VendorBill.vue?vue&type=script&lang=js"
script.render = render

export default script